export const validateRegex = (regexPattern: string, password: string): boolean => {
    if (new RegExp(`^${regexPattern + ".*"}$`).test(password)) {
        return true;
    }
    return false;
} 